module.exports = new __parcel__URL__("data-privacy-darkmode.1a06626c.svg").toString();